import React, { useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
} from 'react-native';
import PlatformIcon from '../common/PlatformIcon';

const MODULE_COLOR = '#F97316';

export interface DescriptionSectionProps {
  description?: string | null;
  showOverviewButton?: boolean;
  onOverviewPress?: () => void;
}

const DescriptionSection: React.FC<DescriptionSectionProps> = ({
  description,
  showOverviewButton = false,
  onOverviewPress,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <View style={styles.section}>
      <View style={styles.sectionHeader}>
        <View style={styles.sectionTitleRow}>
          <PlatformIcon name="description" size={18} color={MODULE_COLOR} family="MaterialIcons" />
          <Text style={styles.sectionTitle}>项目描述</Text>
        </View>
        {showOverviewButton && onOverviewPress && (
          <TouchableOpacity style={styles.overviewButton} onPress={onOverviewPress}>
            <PlatformIcon name="list-alt" size={14} color={MODULE_COLOR} family="MaterialIcons" />
            <Text style={styles.overviewButtonText}>行程总览</Text>
          </TouchableOpacity>
        )}
      </View>
      {description ? (
        <>
          <Text style={styles.descriptionText} numberOfLines={isExpanded ? undefined : 4}>
            {description}
          </Text>
          {description.length > 150 && (
            <TouchableOpacity style={styles.expandButton} onPress={() => setIsExpanded(!isExpanded)}>
              <Text style={styles.expandButtonText}>{isExpanded ? '收起' : '展开'}</Text>
              <PlatformIcon
                name={isExpanded ? 'expand-less' : 'expand-more'}
                size={16}
                color={MODULE_COLOR}
                family="MaterialIcons"
              />
            </TouchableOpacity>
          )}
        </>
      ) : (
        <Text style={styles.emptyText}>暂无项目描述</Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  section: {
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: 16,
    marginBottom: 16,
  },
  sectionHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  sectionTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#1F2937',
    marginLeft: 6,
  },
  overviewButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFF7ED',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: MODULE_COLOR,
  },
  overviewButtonText: {
    color: MODULE_COLOR,
    fontSize: 12,
    fontWeight: '600',
    marginLeft: 4,
  },
  descriptionText: {
    fontSize: 14,
    color: '#4B5563',
    lineHeight: 22,
  },
  emptyText: {
    fontSize: 14,
    color: '#9CA3AF',
    fontStyle: 'italic',
  },
  expandButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 8,
    marginTop: 8,
  },
  expandButtonText: {
    fontSize: 13,
    color: MODULE_COLOR,
    fontWeight: '500',
  },
});

export default DescriptionSection;
